$(document).ready(function() {
  
//  var currenturl = window.location.href;
// var currenturlParams = new URLSearchParams(window.location.search);
// var currentsteps = currenturlParams.get('steps');
 // alert(currentsteps);
    // var results = $('.gets_results');
    // results.each(function() {
    //     var value = $(this).val();
    //     $(this).closest('.radio_option.available.selected').find('.show_result').text(value);
    // });

    // Handle radio option selection
    $(document).on('click', '.radio_option', function() {
    
        $('.radio_option').removeClass('selected');
        $(this).addClass('selected');
    });
  setTimeout(function(){
       $('.unselected').addClass('green_click');

  },900);
    $(document).on('click', '.radio_option.selected_11', function() {
        $('.checkeddd').removeClass('not_green_screen');
        $('.selected_11').addClass('green_screen');
           $('.selected_11').removeClass('on_click');
        $('.unselected').addClass('green_click');

    });
  $(document).on('click', '.radio_option.checkeddd', function() {
        $('.selected_11').removeClass('green_screen');
     $('.selected_11').addClass('on_click');
        $('.checkeddd').addClass('not_green_screen');
    $('.unselected').removeClass('green_click');
    });

    // Add to cart button click
    $(document).on('click', '.ad_to_cart', function(event) {
        event.preventDefault();
        var ID = $('.radio_option.selected').data("variant-id");
        if (!ID) {
            alert('Bitte wählen Sie eine Variante aus.');
            return;
        }

        // AJAX to add the selected product to the cart
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: ID
            },
            dataType: 'json',
            success: function(data) {
                $('#CartCount span:first').text(data.quantity);
                setTimeout(function() {
                    window.location.href = '/cart';
                }, 700);
            },
            error: function() {
                alert('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
            }
        });
    });

    // Disable extras when unselected variant is clicked
    $(document).on('click', '.radio_option.available.unselected', function(event) {
        event.preventDefault();
        $('.extras').addClass('disabled').prop('disabled', true);
    });

    // Enable extras when selected variant is clicked
    $(document).on('click', '.radio_option.available.selected', function(event) {
        event.preventDefault();
        setTimeout(function() {
            $('.extras').removeClass('disabled').prop('disabled', false);
        }, 700);
    });

    // Get query parameter helper
    function getQueryParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return parseInt(urlParams.get(name), 10); // Parse as integer
    }

    // Calculate closest quiz options
    const quizTotal = getQueryParameter('quiz_total');
    let optionDistances = [];

    $('.radio_option').each(function() {
        const optionQuizTotal = $(this).data('quiz-total');
        const distance = Math.abs(optionQuizTotal - quizTotal); // Calculate distance
        optionDistances.push({ distance: distance, element: $(this), optionQuizTotal: optionQuizTotal });
    });

    // Sort by distance (closest first)
    optionDistances.sort(function(a, b) {
        return a.distance - b.distance;
     
    });

    // Take the two closest options
    const closestTwo = optionDistances.slice(0, 2);

    // Sort these two in descending order by their quiz total
    closestTwo.sort(function(a, b) {
        return b.optionQuizTotal - a.optionQuizTotal;
    });

    // Hide all options
    $('.radio_option').hide();

    // Re-append the sorted options and show them
    const parentContainer = $('.radio_option').parent();
    closestTwo.forEach(function(item) {
        parentContainer.append(item.element); // Append sorted option
        item.element.show(); // Show sorted element
    });

    // Automatically select the first (largest) option
    if (closestTwo.length > 0) {
        closestTwo[0].element.addClass('selected selected_11').click();
    }

    // Mark the second option as unselected
    if (closestTwo.length > 1) {
        closestTwo[1].element.addClass('unselected checkeddd');
    }

    // Update the price after selecting an option
    setTimeout(function() {
        var pprice = $('.radio_option.available.selected').data('price');
        console.log(pprice);
        $('.r-1txxw0q.alchemy-rte p').text(pprice);
    }, 2000);

    // Update the price when a selected option is clicked
    $(document).on('click', '.radio_option.available.selected', function(event) {
        event.preventDefault();
        // var pprice = $(this).data('price');
        // $('.extras').removeClass('disabled').prop('disabled', false);
        // $('.r-1txxw0q.alchemy-rte p').text(pprice);
      setTimeout(function(){
    var additional_price_display = $('.selected_11 .additional_price_display').text();
console.log(additional_price_display);
$('span.cmmp_pp p del').text('$' + additional_price_display);

var price_rates = $('.selected_11 span.price_rate').text().replace(/[^0-9,.-]/g, '').trim();
var formatted_price = price_rates + '€'; // Add the Euro symbol after cleaning the number
$('p.pppp_cls').text(formatted_price); // Set the cleaned price with Euro symbol
  },300);
    });
setTimeout(function(){
    var additional_price_display = $('.selected_11 .additional_price_display').text();
console.log(additional_price_display);
$('span.cmmp_pp p del').text( additional_price_display + '€');

var price_rates = $('.selected_11 span.price_rate').text().replace(/[^0-9,.-]/g, '').trim();
var formatted_price = price_rates + '€'; // Add the Euro symbol after cleaning the number
$('p.pppp_cls').text(formatted_price); // Set the cleaned price with Euro symbol
  },300);
      $(document).on('click', '.radio_option.available.unselected', function(event) {
        event.preventDefault();
       var additional_price_display1 = $('.unselected .additional_price_display').text();
console.log(additional_price_display1);
$('span.cmmp_pp p del').text(additional_price_display1 +'€');

//var price_rates1 = $('.unselected span.price_rate').text();
var price_rates1 = $('.unselected span.price_rate').text().replace(/[^0-9,.-]/g, '').trim();
var formatted_price1 = price_rates1 + '€'; // Add the Euro symbol after cleaning the number
$('p.pppp_cls').text(formatted_price1); // Set the cleaned price with Euro symbol
    });

});
